import _ from 'lodash'

export default (items) => (
  _.orderBy(items, ['index', 'asc'], ['name', 'asc'])
)
